  <sharepoint-site-selector>
  <div class="sharepoint-site-selector-container w-full flex flex-col gap-4">
    <!-- Header -->
    <div class="card bg-base-100 shadow-md border border-info/20">
      <div class="card-body gap-2">
        <h3 class="card-title text-lg flex items-center gap-2">
          <i class="icon-business text-xl text-info"></i>
          {locale?.t('sharepoint_selectsite_title')}
        </h3>
        <p class="text-sm text-base-content/80">
          {locale?.t(props.mode === 'folder' ? 'sharepoint_selectsite_description_folder' : 'sharepoint_selectsite_description')}
        </p>
      </div>
    </div>

    <!-- Loading State -->
    <div if="{state.loading}" class="flex justify-center py-12">
      <div class="flex flex-col items-center gap-3">
        <span class="loading loading-spinner loading-lg"></span>
        <p class="text-sm text-base-content/80">{locale?.t('sharepoint_loadingsites')}</p>
      </div>
    </div>

    <!-- Error State -->
    <div if="{state.error && !state.loading}" class="alert alert-error">
      <i class="icon-warning text-xl"></i>
      <span class="text-sm">{state.error}</span>
      <button onclick="{loadSites}" class="btn btn-sm btn-ghost">
        <i class="icon-refresh"></i>
        {locale?.t('retry')}
      </button>
    </div>

    <!-- Search/Filter Toolbar -->
    <div if="{!state.loading && !state.error && state.allSites.length > 0}" class="flex gap-2 items-center">
      <input
        id="sharepoint-site-selector-search"
        type="search"
        placeholder="{locale?.t('sharepoint_searchsites_placeholder')}"
        aria-label="{locale?.t('sharepoint_searchsites_placeholder')}"
        class="input input-bordered input-sm flex-1"
        value="{state.searchQuery}"
        oninput="{(e) => handleSearch(e.target.value)}"
        onsearch="{(e) => handleSearch(e.target.value)}" />

      <button
        onclick="{clearFilter}"
        class="btn btn-sm btn-outline"
        disabled="{!state.searchQuery}">
        <i class="icon-clear me-1"></i>
        {locale?.t('clearfilter')}
      </button>
    </div>

    <!-- Sites List Container with Scrollable Area -->
    <div if="{!state.loading && !state.error && state.allSites.length > 0}" class="sites-list-container flex flex-col gap-0">
      <!-- Scrollable Sites List -->
      <div class="sites-list-scroll space-y-2 overflow-y-auto mb-4" style="max-height: 400px;">
        <div each="{site in state.sites}"
             role="button"
             tabindex="0"
             class="site-item card shadow-sm border border-base-300 hover:border-info transition-all cursor-pointer overflow-hidden relative group"
             onclick="{() => selectSite(site)}"
             onkeydown="{tools?.keyClick(() => selectSite(site))}"
             style="background-color: {site.isPersonalSite ? '#fef3c7' : '#dbeafe'};">
        
        <!-- Background overlay for readability -->
        <div class="site-overlay absolute inset-0 {site.isPersonalSite ? 'bg-yellow-200/20' : 'bg-blue-200/20'} group-hover:opacity-70 opacity-50 transition-opacity"></div>
        
        <div class="card-body py-4 px-6 gap-3 relative z-10">
          <div class="flex items-start gap-4 w-full">
            <!-- Radio Button -->
            <div class="flex items-center pt-1">
              <input
                id="sharepoint-site-selector-radio-{site.id}"
                type="radio"
                name="sharepointSite"
                class="radio radio-info radio-md"
                aria-label="{site.displayName || site.name}"
                checked="{state.selectedSite?.id === site.id}"
                onchange="{() => selectSite(site)}" />
            </div>

            <!-- Site Info -->
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 mb-1">
                <h4 class="font-semibold text-base text-base-content">{site.displayName || site.name}</h4>
                <span if="{site.isPersonalSite}" class="badge badge-warning badge-sm">{locale?.t('sharepoint_myonedrive')}</span>
                <span if="{!site.isPersonalSite}" class="badge badge-info badge-sm">{locale?.t('sharepoint_teamsite')}</span>
              </div>
              <p if="{site.description}" class="text-xs text-base-content/80 mb-1">
                {site.description}
              </p>
              <p if="{site.webUrl}" class="text-xs text-base-content/80 truncate">
                {site.webUrl}
              </p>
              
              <!-- Quota Info -->
              <div if="{site.quota}" class="flex gap-2 mt-2">
                <span class="text-xs text-base-content/80">
                  <i class="icon-storage me-1"></i>
                  {formatSize(site.quota.used)} / {formatSize(site.quota.total)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

    <!-- Empty State (no sites at all) -->
    <div if="{!state.loading && !state.error && state.allSites.length === 0}" class="alert alert-warning">
      <i class="icon-error_outline text-xl"></i>
      <span class="text-sm">{locale?.t('sharepoint_nosites_error')}</span>
    </div>

    <!-- No Search Results -->
    <div if="{!state.loading && !state.error && state.allSites.length > 0 && state.sites.length === 0 && state.searchQuery}" class="card bg-base-100 mb-6">
      <div class="card-body text-center py-6">
        <i class="icon-search text-6xl text-gray-500 mb-2"></i>
        <p class="text-gray-500">{locale?.t('sharepoint_nosearchresults', { searchQuery: state.searchQuery })}</p>
      </div>
    </div>

      <!-- Sticky Action Buttons (Fixed at bottom of list) -->
      <div class="sticky-action-buttons card bg-base-200 shadow-md border border-base-300 border-t-2">
        <div class="card-body py-4 px-6">
          <div class="flex items-center justify-between gap-4">
            <div class="text-sm text-base-content/80">
              <span if="{state.selectedSite}">
                {locale?.t('selected')}: <span class="font-semibold ms-2">{state.selectedSite.displayName || state.selectedSite.name}</span>
              </span>
              <span if="{!state.selectedSite}" class="text-warning">{locale?.t('sharepoint_nositeselected')}</span>
            </div>
            <button
              onclick="{confirmSelection}"
              class="btn btn-primary btn-sm"
              disabled="{!state.selectedSite || state.savingSelection}">
              <i if="{!state.savingSelection}" class="icon-arrow_forward me-1"></i>
              <span if="{state.savingSelection}" class="loading loading-spinner loading-xs me-1"></span>
              {state.savingSelection ? locale?.t('saving') : locale?.t(props.mode === 'folder' ? 'browsefolders' : 'sharepoint_browsefiles')}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- OAuth Reauthorization Modal -->
    <div if="{state.showOAuthModal}" class="modal modal-open">
      <div class="modal-box">
        <h3 class="font-bold text-lg mb-4">
          <i class="icon-warning text-warning me-2"></i>
          {locale?.t('sharepoint_oauth_connectionexpired')}
        </h3>
        <p class="py-4">{state.oauthErrorMessage}</p>
        <div class="modal-action gap-2">
          <button
            onclick="{closeOAuthModal}"
            class="btn btn-ghost">
            {locale?.t('cancel')}
          </button>
          <button
            onclick="{reauthorizeRepository}"
            class="btn btn-primary">
            <i class="icon-refresh me-1"></i>
            {locale?.t('sharepoint_oauth_reauthorizenow')}
          </button>
        </div>
      </div>
      <button type="button" aria-label="{locale?.t('close')}" class="modal-backdrop" onclick="{closeOAuthModal}"></button>
    </div>
  </div>

  <script>
    import { getRepositoryService } from "../services/service-loader";

    export default {
      props: {
        repositoryId: null,
        mode: 'file'
      },

      state: {
        sites: [],
        allSites: [],
        selectedSite: null,
        loading: false,
        error: null,
        savingSelection: false,
        sitesLoaded: false,
        currentSite: null,
        showOAuthModal: false,
        oauthErrorMessage: '',
        oauthErrorCallback: null,
        searchQuery: ''
      },

      async onMounted() {
        // Only load sites once per component instance
        if (!this.state.sitesLoaded) {
          await this.loadSites();
          this.state.sitesLoaded = true;
          this.update();
        }
      },

      async loadSites() {
        try {
          this.state.loading = true;
          this.state.error = null;
          this.update();

          const repositoryService = await getRepositoryService();
          const response = await repositoryService.getSharePointSites(this.props.repositoryId);
          const sites = response.sites || [];
          
          if (!sites || sites.length === 0) {
            this.state.sites = [];
            this.state.allSites = [];
            this.state.error = this.locale.t('sharepoint_nosites_error');
            this.state.loading = false;
          } else {
            // Do NOT auto-select - require user to explicitly select a site
            this.state.sites = sites;
            this.state.allSites = sites;
            this.state.selectedSite = null;
            this.state.error = null;
            this.state.loading = false;
          }
          
          this.update();
        } catch (err) {
          console.error('Failed to load SharePoint sites:', err);
          
          // Check if it's an OAuth token expiration error
          if (err.response?.status === 401 && err.response?.data?.error === 'oauth_token_expired') {
            this.showOAuthExpiredModal(
              err.response.data.message || 'Your repository connection has expired.',
              () => this.loadSites()
            );
            this.state.loading = false;
            this.update();
            return;
          }
          
          this.state.error = err.message || 'Failed to load SharePoint sites. Please try again.';
          this.state.loading = false;
          this.state.sites = [];
          this.state.allSites = [];
          this.update();
        }
      },

      selectSite(site) {
        this.state.selectedSite = site;
        this.update();
      },

      async confirmSelection() {
        if (!this.state.selectedSite) {
          alert(this.locale.t('sharepoint_error_pleaseselect'));
          return;
        }

        // Capture context before async operations
        const context = this;
        const selectedSite = this.state.selectedSite;
        const repositoryId = this.props.repositoryId;

        try {
          context.state.savingSelection = true;
          context.update();

          console.log('[SharePoint Site Selector] Saving site selection:', selectedSite.id);

          const repositoryService = await getRepositoryService();
          const response = await repositoryService.selectSharePointSite(
            repositoryId,
            selectedSite.id
          );
          
          console.log('[SharePoint Site Selector] Site selection saved:', response);
          
          // FIX: Extract driveId from API response - this is CRITICAL for all SharePoint file operations
          const driveId = response.repository?.driveId || selectedSite.driveId;
          
          if (!driveId) {
            console.error('[SharePoint Site Selector] CRITICAL: No driveId in response!', response);
            alert(context.locale.t('sharepoint_error_nodriveid'));
            context.state.savingSelection = false;
            context.update();
            return;
          }
          
          console.log('[SharePoint Site Selector] Emitting site-selected event with driveId:', driveId);
          
          context.state.savingSelection = false;
          context.update();
          
          // Emit event to parent component (file-picker) with proper data structure including driveId
          const eventData = {
            siteId: selectedSite.id,
            driveId: driveId,
            selectedSite: {
              id: selectedSite.id,
              name: selectedSite.name,
              displayName: selectedSite.displayName || selectedSite.name,
              webUrl: selectedSite.webUrl,
              isPersonalSite: selectedSite.isPersonalSite,
              driveId: driveId
            }
          };
          
          // Use global riot object if available, otherwise try direct emit
          if (context.$root && context.$root.$emit) {
            context.$root.$emit('site-selected', eventData);
          } else {
            console.warn('[SharePoint Site Selector] $root.$emit not available, trying window event');
            // Fallback: dispatch custom event on window
            window.dispatchEvent(new CustomEvent('sharepoint-site-selected', {
              detail: eventData
            }));
          }
        } catch (error) {
          console.error('Failed to save SharePoint site selection:', error);
          
          // Check if it's an OAuth token expiration error
          if (error.response?.status === 401 && error.response?.data?.error === 'oauth_token_expired') {
            context.state.savingSelection = false;
            context.showOAuthExpiredModal(
              error.response.data.message || 'Your repository connection has expired.',
              () => context.confirmSelection()
            );
            context.update();
            return;
          }
          
          alert(context.locale.t('sharepoint_error_savefailed') + ': ' + (error.message || 'Unknown error'));
          context.state.savingSelection = false;
          context.update();
        }
      },

      showOAuthExpiredModal(errorMessage, retryCallback) {
        // Show OAuth re-auth modal and store the callback to retry the original action
        this.state.showOAuthModal = true;
        this.state.oauthErrorMessage = errorMessage || this.locale.t('sharepoint_oauth_defaultmessage');
        this.state.oauthErrorCallback = retryCallback;
        this.update();
      },

      async reauthorizeRepository() {
        try {
          const repositoryService = await getRepositoryService();

          // Get OAuth URL
          const oauthData = await repositoryService.getOAuthUrl(this.props.repositoryId);
          
          if (oauthData?.authorizationUrl) {
            // Create a promise that resolves when OAuth completes
            const oauthPromise = new Promise((resolve) => {
              const messageHandler = (event) => {
                // Verify message is from our origin
                if (event.origin !== window.location.origin) return;
                
                // Check for OAuth completion message
                if (event.data?.type === 'repository-connected') {
                  window.removeEventListener('message', messageHandler);
                  resolve(event.data);
                }
              };
              
              // Listen for postMessage from OAuth callback popup
              window.addEventListener('message', messageHandler);
              
              // Timeout after 5 minutes if no response
              setTimeout(() => {
                window.removeEventListener('message', messageHandler);
                resolve({ success: false, timeout: true });
              }, 5 * 60 * 1000);
            });
            
            // Open OAuth popup
            window.open(oauthData.authorizationUrl, 'oauth-popup', 'width=500,height=600');
            
            // Wait for OAuth callback
            const result = await oauthPromise;
            
            // Close modal
            this.state.showOAuthModal = false;
            this.update();
            
            if (result.success !== false) {
              // OAuth succeeded, retry the original action
              const callback = this.state.oauthErrorCallback;
              if (callback && typeof callback === 'function') {
                await callback();
              }
            } else if (result.timeout) {
              alert(this.locale.t('sharepoint_oauth_error_timeout'));
            } else {
              alert(this.locale.t('sharepoint_oauth_error_failed') + ': ' + (result.error || 'Unknown error'));
            }
          } else {
            alert(this.locale.t('sharepoint_oauth_error_nourl'));
          }
        } catch (error) {
          console.error('Failed to re-authorize:', error);
          alert(this.locale.t('sharepoint_oauth_error_reauth') + ': ' + (error.message || 'Unknown error'));
        }
      },

      closeOAuthModal() {
        this.state.showOAuthModal = false;
        this.update();
      },

      handleSearch(query) {
        this.state.searchQuery = query;
        this.update();
        this.filterSites(query);
      },

      clearFilter() {
        this.state.searchQuery = '';
        this.update();
        this.filterSites('');
      },

      filterSites(query) {
        const searchQuery = query.toLowerCase();
        if (!searchQuery) {
          // No query - show all sites
          this.state.sites = this.state.allSites;
          this.update();
          return;
        }

        // Filter sites by name, displayName, or description
        const filteredSites = this.state.allSites.filter(site =>
          site.name?.toLowerCase().includes(searchQuery) ||
          site.displayName?.toLowerCase().includes(searchQuery) ||
          site.description?.toLowerCase().includes(searchQuery)
        );
        this.state.sites = filteredSites;
        this.update();
      },

      formatSize(bytes) {
        if (!bytes || bytes === 0) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
      }
    }
  </script>

  <style>
    :scope {
      --site-item-transition: all 0.2s ease;
    }

    .sharepoint-site-selector-container {
      font-family: inherit;
    }

    /* Container for scrollable sites list */
    .sites-list-container {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }

    /* Scrollable area with max height */
    .sites-list-scroll {
      flex: 1;
      overflow-y: auto;
      padding-right: 8px; /* Account for scrollbar */
    }

    /* Sticky buttons at bottom */
    .sticky-action-buttons {
      flex-shrink: 0;
      margin-top: auto;
      box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    }

    .site-item {
      transition: var(--site-item-transition);
      position: relative;
    }

    .site-item:hover {
      transform: translateX(4px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    .site-overlay {
      transition: opacity 0.2s ease;
    }

    .site-item input[type="radio"]:checked {
      accent-color: hsl(var(--in));
    }
  </style>
</sharepoint-site-selector>
